<template>
  <router-link
    :to="to"
    custom
    :exact="exact"
    v-slot="{ href, navigate, isExactActive }"
    v-if="!isAbsolute"
  >
    <li class="sidenav-link">
      <a
        class="aligner"
        @click="
          (event) => {
            toggleNavBarMobile()
            refreshOnNavigate ? goTo({ href, event }) : navigate(event)
          }
        "
      >
        <slot />
      </a>
      <span v-if="badge" class="badge">{{ badge }}</span>
    </li>
  </router-link>
  <a :href="to" v-else class="sidenav-link">
    <li>
      <a class="aligner">
        <slot />
      </a>
      <span v-if="badge" class="badge">{{ badge }}</span>
    </li>
  </a>
</template>

<script>
import isString from 'lodash/isString'
import { mapMutations, mapState } from 'vuex'
import { getNewAppUrl } from '@/utils/urls'

export default {
  props: {
    to: {
      type: [Object, String],
      default: () => ({}),
    },
    icon: {
      type: String,
      default: '',
    },
    exact: {
      type: Boolean,
      default: false,
    },
    badge: {
      type: String,
      default: null,
    },
    refreshOnNavigate: Boolean,
    linkToNewApp: Boolean,
  },
  computed: {
    ...mapState({
      navBarMobileVisible: (state) => state.common.navBarMobileVisible,
    }),
    isAbsolute() {
      if (
        isString(this.to) &&
        (this.to.startsWith('http:') || this.to.startsWith('https:'))
      ) {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapMutations({
      setNavBarMobileVisibility: 'common/TOGGLE_NAV_BAR_MOBILE',
    }),
    toggleNavBarMobile() {
      if (
        (this.$mq === 'break-xs' || this.$mq === 'break-small') &&
        this.navBarMobileVisible
      ) {
        this.setNavBarMobileVisibility()
      }
    },
    goTo({ event, href }) {
      event.preventDefault()
      event.stopPropagation()
      const newHref = this.linkToNewApp ? getNewAppUrl(href) : href
      location.href = getNewAppUrl(newHref)
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.sidenav-link {
  position: relative;
  .badge {
    position: absolute;
    top: 22px;
    right: 18px;
    z-index: 1;
  }
}

.sidebar-collapsed {
  .sidenav-link {
    .badge {
      right: 10px;
    }
  }
}

.sidenav-link.subpage {
  .title {
    padding-left: 10px;
  }
}
</style>
